module.exports = __webpack_public_path__ + "static/Leidy-Arias-96bcf2e4a0caa2e96136de5bda79a6b3.png";